module.exports = __webpack_public_path__ + "img/user_Headportrait.0cfde19f.png";